import * as yup from "yup";

export const validationSchema = yup.object({
    confidentialityNda: yup
        .mixed()
        .transform((value) => {
            // Transform array to boolean: true if array contains "true", false otherwise
            return Array.isArray(value) && value.includes("true");
        })
        .oneOf([true], "Please agree to the above Confidentiality Statement")
});